import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Dashboard() {
  const [member, setMember] = useState(null);
  const [events, setEvents] = useState([]);
  const [rsvpStatus, setRsvpStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [posting, setPosting] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [meRes, eventsRes] = await Promise.all([
        api.get('/member-auth/me'),
        api.get('/touring-events/'),
      ]);
      setMember(meRes.data);
      setEvents(eventsRes.data);

      const statusMap = {};
      await Promise.all(
        eventsRes.data.map(async (ev) => {
          try {
            const r = await api.get(`/touring-events/${ev.id}/me`);
            statusMap[ev.id] = r.data;
          } catch {
            statusMap[ev.id] = null;
          }
        })
      );
      setRsvpStatus(statusMap);

      const msgRes = await api.get('/messages/');
      setMessages(msgRes.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePostMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    setPosting(true);
    try {
      await api.post('/messages/', { message: newMessage.trim() });
      setNewMessage('');
      const msgRes = await api.get('/messages/');
      setMessages(msgRes.data);
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal mengirim pesan');
    } finally {
      setPosting(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRsvp = async (eventId, ikut) => {
    try {
      await api.post(`/touring-events/${eventId}/rsvp`, { ikut });
      fetchData();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal RSVP');
    }
  };

  if (loading) {
    return (
      <Layout>
        <p style={{ color: '#8B92A0' }}>Memuat...</p>
      </Layout>
    );
  }

  return (
    <Layout>
      <p style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>
        Hai, {member?.name} 👋
      </p>
      <h1 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 24px' }}>
        Dashboard Member
      </h1>

      {!member?.approved && (
        <div style={{
          background: 'rgba(43,105,150,0.1)', border: '1px solid #2B6996', color: '#8fb4d1',
          padding: '14px 18px', borderRadius: 6, fontSize: 13, marginBottom: 28,
        }}>
          ⏳ Akun kamu masih menunggu approval admin. Setelah di-approve, kamu bisa RSVP touring & posting di Message Board.
        </div>
      )}

      <div style={{
        background: '#1C2128', border: '1px solid #262b33', padding: 24, marginBottom: 32,
        clipPath: 'polygon(0 0, 100% 0, 100% 94%, 96% 100%, 0 100%)',
      }}>
        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
          <div style={{
            width: 70, height: 70, borderRadius: '50%', background: '#262b33', flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
          }}>
            {member?.photo_url ? (
              <img src={member.photo_url} alt={member.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              <span style={{ fontSize: 24 }}>👤</span>
            )}
          </div>
          <div>
            <p style={{ fontWeight: 800, fontSize: 18 }}>{member?.name}</p>
            <p style={{ color: '#D02127', fontSize: 12, fontWeight: 700, textTransform: 'uppercase' }}>{member?.position}</p>
            <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 2 }}>{member?.motor_type || 'Belum diisi jenis motor'}</p>
          </div>
        </div>
      </div>

      <h2 style={{ fontSize: 20, fontWeight: 800, fontStyle: 'italic', marginBottom: 16 }}>Event Touring</h2>
      {(() => {
        const ongoingList = events.filter((e) => e.status === 'ongoing').slice(0, 1);
        const selesaiList = events.filter((e) => e.status === 'selesai').slice(0, 1);
        const upcomingList = events.filter((e) => e.status === 'upcoming').slice(0, 1);
        const displayEvents = [...ongoingList, ...upcomingList, ...selesaiList];
        return displayEvents.length === 0 ? (
          <p style={{ color: '#8B92A0', fontSize: 14 }}>Belum ada event touring.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {displayEvents.map((ev) => {
            const myRsvp = rsvpStatus[ev.id];
            return (
              <div
                key={ev.id}
                style={{
                  background: '#1C2128', border: '1px solid #262b33', padding: 18,
                  clipPath: 'polygon(0 0, 98% 0, 100% 100%, 2% 100%)',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
                  <div>
                    <p style={{ fontWeight: 800, fontSize: 15 }}>{ev.title}</p>
                    <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 4 }}>
                      📍 {ev.location || '-'} · 📅 {new Date(ev.tanggal_mulai).toLocaleDateString('id-ID')}
                    </p>
                    {ev.biaya > 0 && (
                      <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 2 }}>💰 Rp {ev.biaya.toLocaleString('id-ID')}</p>
                    )}
                  </div>
                  <span style={{
                    fontSize: 11, fontWeight: 700, textTransform: 'uppercase', padding: '4px 10px', borderRadius: 4,
                    background: ev.status === 'ongoing' ? 'rgba(208,33,39,0.15)' : 'rgba(43,105,150,0.15)',
                    color: ev.status === 'ongoing' ? '#D02127' : '#2B6996',
                  }}>
                    {ev.status}
                  </span>
                </div>

                {ev.status === 'ongoing' && (
                  <a href="/live-touring" style={{
                    display: 'inline-block', marginTop: 10, marginBottom: 6, color: '#D02127', fontSize: 12, fontWeight: 700, textDecoration: 'none',
                  }}>
                    → Buka Live Touring (post checkpoint)
                  </a>
                )}
                {ev.status === 'selesai' ? (
                  myRsvp && (
                    <p style={{ fontSize: 12, color: myRsvp.ikut ? '#4ADE80' : '#8B92A0', marginTop: 10 }}>
                      {myRsvp.ikut ? '✓ Kamu ikut' : 'Tidak ikut'}
                    </p>
                  )
                ) : member?.approved ? (
                  <div style={{ marginTop: 14, display: 'flex', gap: 10, alignItems: 'center' }}>
                    {myRsvp ? (
                      <>
                        <span style={{ fontSize: 12, color: myRsvp.ikut ? '#4ADE80' : '#8B92A0' }}>
                          {myRsvp.ikut ? '✓ Kamu ikut' : 'Tidak ikut'}
                          {ev.biaya > 0 && myRsvp.ikut && ` · Bayar: ${myRsvp.status_bayar}`}
                        </span>
                        <button
                          onClick={() => handleRsvp(ev.id, !myRsvp.ikut)}
                          style={{ background: 'transparent', border: '1px solid #262b33', color: '#8B92A0', padding: '6px 12px', borderRadius: 6, fontSize: 11, cursor: 'pointer' }}
                        >
                          Ubah
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => handleRsvp(ev.id, true)}
                          style={{ background: '#D02127', border: 'none', color: '#fff', padding: '8px 16px', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}
                        >
                          Ikut
                        </button>
                        <button
                          onClick={() => handleRsvp(ev.id, false)}
                          style={{ background: 'transparent', border: '1px solid #262b33', color: '#8B92A0', padding: '8px 16px', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}
                        >
                          Tidak Ikut
                        </button>
                      </>
                    )}
                  </div>
                ) : (
                  <p style={{ fontSize: 12, color: '#5a616e', marginTop: 10 }}>RSVP tersedia setelah akun di-approve admin.</p>
                )}
              </div>
            );
          })}
        </div>
        );
      })()}

      <a href="/history" style={{ display: 'inline-block', marginTop: 14, color: '#2B6996', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
        → Lihat Semua Riwayat Touring
      </a>

      <h2 style={{ fontSize: 20, fontWeight: 800, fontStyle: 'italic', margin: '32px 0 16px' }}>Papan Pesan</h2>
      {member?.approved ? (
        <form onSubmit={handlePostMessage} style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
          <input
            type="text"
            placeholder="Tulis pesan..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            style={{ flex: 1, background: '#1C2128', border: '1px solid #262b33', borderRadius: 6, padding: '10px 14px', color: '#F0EDE4', fontSize: 14 }}
          />
          <button
            type="submit"
            disabled={posting}
            style={{ background: '#D02127', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: 6, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}
          >
            {posting ? '...' : 'Kirim'}
          </button>
        </form>
      ) : (
        <p style={{ fontSize: 12, color: '#5a616e', marginBottom: 20 }}>Tulis pesan tersedia setelah akun di-approve admin.</p>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {messages.slice(0, 10).map((m) => (
          <div key={m.id} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 14 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 6 }}>
              <span style={{ fontWeight: 700, fontSize: 13 }}>{m.member_name}</span>
              <span style={{ color: '#D02127', fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>{m.member_position}</span>
            </div>
            <p style={{ fontSize: 13, marginTop: 6, color: '#c8ccd3' }}>{m.message}</p>
          </div>
        ))}
      </div>
    </Layout>
  );
}
